<template lang="html">
  <div class="shopify-remove-channel">
    <Guide
      :content="content"
      contentHeading="Remove Online Store Channel"
      :contentImage="contentImage"
      :closeLink="closeLink"
      :nextLink="nextLink"
      :previousLink="previousLink"/>
  </div>
</template>

<script>
import Guide from '@/components/Guide'

export default {
  name: 'ShopifyRemoveChannel',

  components: {
    Guide
  },

  props: {
    siteId: String,
    companyId: String
  },

  computed: {
    closeLink() {
      return {
        name: 'shopify-settings',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    nextLink() {
      return {
        name: 'complete-sign-up',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    previousLink() {
      return {
        name: 'locate-sales-channels',
        params: {
          companyId: this.companyId, siteId: this.siteId
        }
      }
    },

    content() {
      return `
          <p>To remove the <strong>Online Store</strong>, hit the trash icon, located on the right of the <strong>Online Store</strong> sales channel. This will bring up the confirmation pop up. Use the <strong>Remove channel</strong> button to proceed.</p>

          <p>If your 14 trial has expires, you will not have the option to select the <strong>Shopify Lite</strong> plan. You can <a href="https://help.shopify.com/en/questions#/contact/chat" target="_blank">contact a Shopify Guru</a>, they can remove the online store on your behalf so the Lite plan will become available.</p>

          <hr>

          <div class="helper-text">
            <p><strong>Example message:</strong></p>
            <p>Hello. I would like to continue using Shopify on the Lite plan. Could you please remove the Online Store from my sales channels so I can proceed with this?</p>
          </div>
        `
    },

    contentImage() {
      return 'https://cdn.shopify.com/assets2/homepage/market-large-2528e56549556ee74247a6ed563d33211d7d8ebfa7760a44c2612602a5774fd3.jpg'
    }
  }
}
</script>

<style lang="sass">
  .shopify-guide
</style>
